module.exports = __webpack_public_path__ + "static/10-0ea3b996be57e6d22425d2a6df4c891e.jpg";